import { render, staticRenderFns } from "./Q9.vue?vue&type=template&id=d20dc938&"
import script from "./Q9.vue?vue&type=script&lang=js&"
export * from "./Q9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports